<div class="ToolbarContent Flexbox Align--center Gap--smaller Justify--space-between">
  <div class="ContentContainer Flexbox Align--center Gap--smaller">
    <button class="HiddenDesktop" mat-icon-button color="warn" (click)="reset()"><mat-icon>restart_alt</mat-icon></button>
    <button class="HiddenDesktop" mat-icon-button [disabled]="!canUndo()" (click)="undo()"><mat-icon>undo</mat-icon></button>
    <button class="HiddenDesktop" mat-icon-button [disabled]="!canRedo()" (click)="redo()"><mat-icon>redo</mat-icon></button>
  </div>
  <div class="RightContent Flexbox Align--center Gap--smaller">
  <div class="Flexbox Flexbox--column Align--flex-start Gap--tiny">
    @if (shouldShowPrice()) {
      <div class="PriceContainer Flexbox Flexbox--column Justify--space-between Gap--smallest">
        @if (isRetailOnlyMode()) {
          <app-price [price]="retailPrice()" [type]="'retailer'"></app-price>
        } @else {
          @if (shouldShowWholesalePrice()) {
            <app-price [price]="wholesalePriceToShow()" [displayStyle]="'compact'" [type]="'wholesale'"></app-price>
          }
          <app-price [price]="retailPrice()" [displayStyle]="shouldShowWholesalePrice() ? 'compact' : 'normal'" [type]="'retail'"></app-price>
        }
      </div>
    }
  </div>
    @if (!isRetailOnlyMode() || canRetailerAddToCart() || !isReviewing()) {
    <button mat-raised-button class="ReviewButton ThemeColorPrimary" (click)="reviewClicked()">
      <div class="Flexbox Align--center Gap--smaller">
        @if (!isReviewing()) {
          <span>Review</span>
        } @else {
          <span>Add to Cart</span>
        }
      </div>
    </button>
    }
  </div>
</div>
